import APIServices from '../services/APIServices';

export const fetchRolesList = async (setRoles, setLoading, setError, isOrgUser = false) => {
  setLoading(true);
  try {
    const response = await APIServices.get(`/user-roles?type=${isOrgUser ? 2 : 1}`); // Adjust the URL as necessary
    if (response.userRoles) {
      const mappedRoles = response.userRoles.map((role) => ({
        value: role.role, // Use 'role' as the value
        label: role.name,
        id: role._id // Use 'name' as the label
      }));
      setRoles(mappedRoles);
    }
  } catch (error) {
    setError(error.message);
  } finally {
    setLoading(false);
  }
};

export const fetchPermissions = async (setPermissions) => {
  try {
    const response = await APIServices.get('/permissions'); // Adjust the URL as necessary

    if (response.length > 0) {
      const permissionsData = response;

      const formattedPermissions = permissionsData.map((permission) => ({
        value: permission._id, // or permission._id if needed
        label: permission.name
      }));

      setPermissions(formattedPermissions);
    }
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};

export const fetchTeamMembers = async (
  setTeams,
  setCurrentUser,
  setLoading,
  user,
  includeme = false,
  filtered = 'accepted',
  isActive = false,
  setDefaultTeam = () => {}
) => {
  let membersOptions = [];
  let currentUser = {};
  try {
    const response = await APIServices.get(
      `/team/${user?.companyId?._id}?status=${filtered}&includeMe=${includeme}&type=all`
    );
    if (response.members) {
      currentUser = response.members.find((x) => x._id === user._id);
      setCurrentUser(currentUser);
      membersOptions = response.members.map((member) => ({
        value: member._id, // or permission._id if needed
        label: member.fullName,
        role: member.userType._id,
        roleName: member.userType.role,
        email: member.email
      }));
      // membersOptions = membersOptions.filter(x=>x.value != user._id)
      setTeams(membersOptions || []);
      if (setDefaultTeam) {
        setDefaultTeam(membersOptions || []);
      }
    } else if (response?.data?.message) {
      setTeams([]);
    }
  } catch (error) {
    console.error('Error fetching the teams:', error);
  } finally {
    setLoading(false);
  }
};

export const fetchEnumOptions = async (enumName) => {
  try {
    const response = await APIServices.get(`/enum?item_type=${enumName}`); // Adjust the URL as necessary

    if (response.length > 0) {
      // const optionsData = response;

      // const formattedPermissions = optionsData.map((option) => ({
      //   value: option._id,
      //   label: option.name,
      // }));

      // setData(formattedPermissions);
      return response;
    }
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};

// this api will be triggeres while creating new project/template in milstone screen
export const fetchProjectTeamMembers = async (
  projectId,
  setData,
  type = '',
  projectType = 'external',
  includeMe = false
) => {
  try {
    const response = await APIServices.get(
      `/project-team/${projectId}?type=${type}&includeMe=${includeMe}&projectType=${projectType}`
    );

    if (response.teamMembers.length > 0) {
      const optionsData = response.teamMembers;
      // console.log(optionsData);

      const formattedMembers = optionsData.map((option) => ({
        value: option.userId?._id,
        label: option.userId?.fullName,
        profilePic: option.userId?.profilePic
      }));
      // console.log(formattedMembers);
      if (setData) {
        setData(formattedMembers);
      }
      return formattedMembers;
    }
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};

// this api will be triggeres while creating new project/template in milstone screen
export const fetchProjectTeamMemberswithNone = async (projectId, setData, type = '') => {
  try {
    let updatedTeam = [];
    const projectTeam = await fetchProjectTeamMembers(projectId, setData, type, 'external', true);

    updatedTeam = [
      {
        value: null,
        label: 'None'
      },
      ...projectTeam
    ];
    console.log('updatedTeam', updatedTeam);

    setData(updatedTeam);
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};

// this api will be used to get the list of milestones of a project
export const fetchProjectMilestones = async (projectId, tyepeOf = '') => {
  try {
    const response = await APIServices.get(`/project-milestone?projectId=${projectId}&type=${tyepeOf}`);
    if (response.length > 0) {
      return response;
    }
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};

//fetch all the members of team
export const fetchAllTeamMembers = async (setData) => {
  try {
    const response = await APIServices.get('/project-team/all/member'); // Adjust the URL as necessary

    if (response.data.length > 0) {
      let filteredMembers = response.data.filter((member) => member.fullName);
      const formattedMembers = filteredMembers.map((member) => ({
        value: member._id, // or permission._id if needed
        label: member.fullName
      }));
      formattedMembers.unshift({
        value: '', // or permission._id if needed
        label: 'All members'
      });
      setData(formattedMembers);
    }
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};

// Fetch organizations data
export const fetchOrganizations = async () => {
  try {
    const response = await APIServices.get(`/organizations?type=active&status=true`); // Adjust the URL as necessary
    if (response.organizations) {
      // Map the response to match the react-select option format
      const orgOptions = response.organizations.map((org) => ({
        label: org.name, // Display name as label
        value: org._id // Use _id as value
      }));
      return orgOptions;
    }
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};

export const fetchFrequencyOptions = async (setFrequencyOptions) => {
  try {
    const response = await APIServices.get('/enum?item_type=recurrenceFrequency'); // Adjust the URL as necessary

    if (response.length > 0) {
      const options = response;

      const formattedOptions = options.map((option) => ({
        _id: option._id,
        value: option.value, // or permission._id if needed
        label: option.name
      }));
      if (setFrequencyOptions) {
        setFrequencyOptions(formattedOptions);
      }
      // return formattedOptions;
    }
  } catch (error) {
    console.error('Error fetching options:', error);
  }
};

export const fetchDateTypes = async (setDateTypes) => {
  try {
    const response = await APIServices.get('/enum?item_type=dateType'); // Adjust the URL as necessary

    if (response.length > 0) {
      const options = response;

      const formattedOptions = options.map((option) => ({
        _id: option._id,
        value: option.value, // or permission._id if needed
        label: option.name
      }));
      if (setDateTypes) {
        setDateTypes(formattedOptions);
      }
      // return formattedOptions;
    }
  } catch (error) {
    console.error('Error fetching options:', error);
  }
};

export const fetchGeneralMilestones = async () => {
  try {
    const response = await APIServices.post(`/project-milestone/assigned-with-due`); // Adjust the URL as necessary

    if (response) {
      return response;
    }
  } catch (error) {
    console.error('Error fetching permissions:', error);
  }
};

export const fetchProjectData = async (projectId) => {
  if (!projectId) return null;

  try {
    const response = await APIServices.get(`/project/${projectId}`);

    if (!response.projectDetail) return null;

    return {
      projectName: response.projectDetail.projectName
    };
  } catch (error) {
    console.error('Error fetching project data:', error);
    return null;
  }
};
